import * as Sentry from '@sentry/react'

/**
 * Initialize Sentry with configuration
 */
export const initializeSentry = (options?: {
  environment?: string
  debug?: boolean
}) => {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = options?.environment || import.meta.env.VITE_ENV || 'local';
  
  // Validate DSN
  if (!dsn) {
    console.warn('VITE_SENTRY_DSN is not set. Sentry will not work.');
    return;
  }
  
  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '1.0'),
    debug: options?.debug ?? (import.meta.env.VITE_SENTRY_DEBUG === 'true'),
    integrations: [Sentry.replayIntegration()],
    // Session Replay Configuration
    replaysSessionSampleRate: parseFloat(
      import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE || '1.0',
    ),
    replaysOnErrorSampleRate: parseFloat(
      import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE || '1.0',
    ),
  })
}

/**
 * Initialize Sentry for test environment
 */
export const initializeSentryForTests = () => {
  initializeSentry({
    environment: import.meta.env.VITE_ENV + '-test',
    debug: false
  })
}
